import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { showToast } from "../helper/ShowToast";
import { hasArtistLinked, hasFullLinksFanHubAccess } from "../helper/access";

const LINKS_FAN_HUB_PATH = "/admin/artist-manager/link-and-fan-hub";

/**
 * Blocks direct navigation to Links & Fan Hub builder/edit routes when the user
 * has not linked an artist or does not have an active subscription.
 */
export const LinksFanHubRouteGuard = ({ children }) => {
    const access = useSelector((state) => state.auth.access);
    const userDetails = useSelector((state) => state.auth.userDetails);
    const billing = useSelector((state) => state.billing);
    const toastedRef = useRef(false);

    const needsLinkArtist = !hasArtistLinked(access, userDetails);
    const hasFullAccess = hasFullLinksFanHubAccess(access, userDetails, billing);

    useEffect(() => {
        if (toastedRef.current) return;

        if (needsLinkArtist) {
            showToast("info", "Link your artist profile to unlock Links & Fan Hub.");
            toastedRef.current = true;
            return;
        }

        if (!hasFullAccess) {
            showToast("info", "Please subscribe to unlock Links & Fan Hub.");
            toastedRef.current = true;
        }
    }, [needsLinkArtist, hasFullAccess]);

    if (needsLinkArtist) {
        return <Navigate to="/link-accounts" replace />;
    }

    if (!hasFullAccess) {
        return (
            <Navigate
                to={LINKS_FAN_HUB_PATH}
                replace
                state={{ openGoPro: true }}
            />
        );
    }

    return children;
};
